import { Link } from "react-router-dom"
import ArrowIcon from "../Icons/ArrowIcon"
import { useState } from "react";

const BlogCard = ({img, id, title , description } : {img?:string;id?:string;title?:string; description:string}) => {
    const [showFullDescription,] = useState(false);
    const descriptionWords = description?.split(' ');
    const truncatedDescription = showFullDescription ? descriptionWords.join(' ') : descriptionWords.slice(0, 25).join(' ');

  return (
    <div className="bg-white rounded-lg flex flex-col h-full">
        <Link to={`/blog/${id}`}>
        <img src={img} alt="blog1" className="rounded-t-lg w-full h-[200px]" />
</Link>
    <div className="px-4 py-5 border-burntBlack/15 border rounded-b-lg h-full flex flex-col">
        <h2 className="font-semibold text-xl text-textSecondary mb-2">{title}</h2>
        <Link to={`/blog/${id}`}> <p className="font-medium text-sm mb-4">{truncatedDescription} <span className="text-primary">...</span> </p></Link>
        <Link to={`/blog/${id}`} className="font-semibold text-primary flex gap-1 items-center mt-auto">Learn More <ArrowIcon className="rotate-180 size-4"/></Link>
    </div>
</div>
)
}

export default BlogCard